

























import {Component, Prop, Vue} from 'vue-property-decorator'


@Component({
  components: {},
})
export default class TabForDialog extends Vue {
  @Prop() tab: any
}

